import React from 'react';
import './index.scss';

const CustomSpinner = () => {
  return (
    <div className="spinner"></div>
  )
};

export default CustomSpinner;